import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';

const Home = lazy(() => import('./pages/Home'));
const Contact = lazy(() => import('./pages/Contact'));
const TermsPdfRedirect = lazy(() => import('./pages/TermsPdfRedirect'));
const CookiePolicy = lazy(() => import('./pages/CookiePolicy'));
const Imprint = lazy(() => import('./pages/Imprint'));

function PageLoader() {
  return (
    <div className="flex min-h-[200px] items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent" />
    </div>
  );
}

export function AppRoutes() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="contact" element={<Contact />} />
          <Route
            path="privacy"
            element={<Navigate to="cookies" replace relative="path" />}
          />
          <Route path="terms" element={<TermsPdfRedirect />} />
          <Route path="algemene-voorwaarden" element={<TermsPdfRedirect />} />
          <Route path="cookies" element={<CookiePolicy />} />
          <Route path="imprint" element={<Imprint />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
